import styled from "styled-components";

export const Title = styled.h1`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  margin: 0px 0px 24px 0px;

  @media (min-width: 1024px) {
    grid-template-columns: auto 200px 200px 200px;
    margin-bottom: 20px;
  }
`;

export const FiltersContainer = styled("div")`
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  margin-bottom: 16px;
  transition: all 0.2s ease;
`;

// CAMBIAR EL HEADER DE FILTROS:
export const FiltersHeader = styled("div")`
  padding: 20px 24px;
  border-bottom: 2px solid #e5e7eb;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  transition: all 0.3s ease;
  border-radius: 8px 8px 0 0;
  position: relative;
  
  /* Borde izquierdo llamativo */
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 5px;
    background: #6b5ce7;
    border-radius: 4px 0 0 4px;
  }
  
  /* Indicador de que es clickeable */
  &::after {
    position: absolute;
    right: 50px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 11px;
    color: #6b7280;
    opacity: 0.7;
    font-weight: 500;
  }
  
  &:hover {
    background: linear-gradient(135deg, #f0f4ff 0%, #e8f2ff 100%);
    border-bottom-color: #6b5ce7;
    box-shadow: 0 2px 8px rgba(107, 92, 231, 0.1);
    
    &::after {
      opacity: 1;
    }
  }
  
  @media (max-width: 768px) {
    padding: 18px 20px;
    
    &::after {
      display: none; /* Ocultar en móvil */
    }
  }
`;

// TÍTULO MÁS OBVIO:
export const FiltersTitle = styled("div")`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  
  /* Hacer más obvio que es clickeable */
  &::after {
    content: '▼';
    font-size: 12px;
    color: #6b5ce7;
    transition: transform 0.2s ease;
  }
  
  .expanded &::after {
    transform: rotate(180deg);
  }
`;

// TOGGLE MÁS CLARO:
export const FiltersToggle = styled("div")`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #6b5ce7;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 16px;
  background: white;
  border: 2px solid #6b5ce7;
  border-radius: 20px;
  transition: all 0.2s ease;
  
  svg {
    transition: transform 0.2s ease;
  }
  
  &.expanded {
    background: #6b5ce7;
    color: white;
    
    svg {
      transform: rotate(180deg);
    }
  }
  
  &:hover {
    transform: scale(1.05);
  }
`;

export const FiltersBody = styled("div")<{ expanded: boolean }>`
  max-height: ${props => props.expanded ? '1000px' : '0'};
  overflow: hidden;
  transition: max-height 0.3s ease;
  position: relative;
  z-index: 10;
  
  .filters-content {
    padding: ${props => props.expanded ? '16px' : '0 16px'};
    opacity: ${props => props.expanded ? '1' : '0'};
    transition: opacity 0.2s ease;
  }
  
  /* Ensure dropdowns appear above everything */
  .react-select__menu {
    z-index: 9999 !important;
  }
  
  .react-select__menu-portal {
    z-index: 9999 !important;
  }
  
  @media (max-width: 768px) {
    .filters-content {
      padding: ${props => props.expanded ? '16px' : '0 16px'};
    }
  }
`;

export const FilterSection = styled("div")`
  margin-bottom: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const FilterSectionTitle = styled("h4")`
  margin: 0 0 12px 0;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border-bottom: 1px solid #f3f4f6;
  padding-bottom: 6px;
`;

export const Filters = styled("div")`
  display: grid;
  grid-gap: 12px;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  }
  
  @media (min-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const SortFilters = styled("div")`
  display: grid;
  grid-gap: 12px;
  
  @media (min-width: 768px) {
    grid-template-columns: 1fr auto;
    align-items: end;
  }
  
  /* Fix for sort select dropdown z-index */
  .sort-select-container {
    position: relative;
    z-index: 100;
    
    .react-select__menu {
      z-index: 9999 !important;
    }
    
    .react-select__menu-portal {
      z-index: 9999 !important;
    }
    
    /* Ensure the dropdown doesn't get cut off by align-items: end */
    .react-select__control {
      position: relative;
      z-index: 1;
    }
  }
`;

export const FilterGroup = styled("div")`
  position: relative;
  
  /* Enhanced focus styles for better accessibility */
  &:focus-within .filter-label {
    color: #6b5ce7;
    font-weight: 600;
  }
`;

export const ClearFiltersButton = styled("button")`
  background: none;
  border: 1px solid #e5e7eb;
  color: #6b7280;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  
  &:hover {
    background: #f9fafb;
    border-color: #d1d5db;
    color: #374151;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    padding: 12px 16px;
    font-size: 15px;
  }
`;

export const ActionsContainer = styled("div")`
  display: flex;
  gap: 12px;
  align-items: end;
  
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    gap: 8px;
  }
`;

export const ActiveFiltersIndicator = styled("div")`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #6b5ce7;
  font-size: 12px;
  font-weight: 500;
`;

export const FilterCount = styled("span")`
  background: #6b5ce7;
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 10px;
  min-width: 16px;
  text-align: center;
`;

export const FilterLabel = styled("span")`
  display: block;
  font-weight: 500;
  color: #374151;
  margin-bottom: 6px;
  font-size: 14px;
`;


export const IconLink = styled("a")`
  color: inherit;
  text-decoration: none;
  margin: 0px;
  padding: 0px;
  border: 0px;
  background: none;
  cursor: pointer;
`;